/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionDetailed } from './SubscriptionDetailed';
import {
    SubscriptionDetailedFromJSON,
    SubscriptionDetailedFromJSONTyped,
    SubscriptionDetailedToJSON,
    SubscriptionDetailedToJSONTyped,
} from './SubscriptionDetailed';

/**
 * 
 * @export
 * @interface ChangeBillingSubscription200Response
 */
export interface ChangeBillingSubscription200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ChangeBillingSubscription200Response
     */
    requiresPayment?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeBillingSubscription200Response
     */
    isDowngrade?: boolean;
    /**
     * 
     * @type {SubscriptionDetailed}
     * @memberof ChangeBillingSubscription200Response
     */
    subscription?: SubscriptionDetailed;
    /**
     * 
     * @type {string}
     * @memberof ChangeBillingSubscription200Response
     */
    checkoutUrl?: string;
}

/**
 * Check if a given object implements the ChangeBillingSubscription200Response interface.
 */
export function instanceOfChangeBillingSubscription200Response(value: object): value is ChangeBillingSubscription200Response {
    return true;
}

export function ChangeBillingSubscription200ResponseFromJSON(json: any): ChangeBillingSubscription200Response {
    return ChangeBillingSubscription200ResponseFromJSONTyped(json, false);
}

export function ChangeBillingSubscription200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeBillingSubscription200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'requiresPayment': json['requiresPayment'] == null ? undefined : json['requiresPayment'],
        'isDowngrade': json['isDowngrade'] == null ? undefined : json['isDowngrade'],
        'subscription': json['subscription'] == null ? undefined : SubscriptionDetailedFromJSON(json['subscription']),
        'checkoutUrl': json['checkoutUrl'] == null ? undefined : json['checkoutUrl'],
    };
}

export function ChangeBillingSubscription200ResponseToJSON(json: any): ChangeBillingSubscription200Response {
    return ChangeBillingSubscription200ResponseToJSONTyped(json, false);
}

export function ChangeBillingSubscription200ResponseToJSONTyped(value?: ChangeBillingSubscription200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requiresPayment': value['requiresPayment'],
        'isDowngrade': value['isDowngrade'],
        'subscription': SubscriptionDetailedToJSON(value['subscription']),
        'checkoutUrl': value['checkoutUrl'],
    };
}

